export { EloDeleteIcon } from './delete-icon'
